import React from 'react';
import { usePrevious } from 'hooks';
import { makeVar, useReactiveVar } from '@apollo/client';

const surfaceIdVar = makeVar<string | null>(null);

type OnSurfaceChangeCallback = (surface: string | null) => void;

export default function useOnSurfaceChange(callBack: OnSurfaceChangeCallback) {
  const surface = useReactiveVar(surfaceIdVar);

  const previousSurface = usePrevious(surface);

  React.useEffect(() => {
    if (surface !== previousSurface) {
      callBack(surface);
    }
  }, [previousSurface, surface]);
}

export function useOnSurfaceChangeOperations(): {
  setSurfaceId(id: string): void;
} {
  return { setSurfaceId };
}

function setSurfaceId(id: string): void {
  if (surfaceIdVar() !== id) {
    surfaceIdVar(id);
  }
}

export function useCurrentSurfaceId(): string | null {
  return useReactiveVar(surfaceIdVar);
}
